import { render } from "./ks-bio-photo.vue?vue&type=template&id=06d067ae"
import script from "./ks-bio-photo.vue?vue&type=script&lang=js"
export * from "./ks-bio-photo.vue?vue&type=script&lang=js"

import "./ks-bio-photo.vue?vue&type=style&index=0&id=06d067ae&lang=css"
script.render = render

export default script